module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-rojo.a8150629.svg";